module.exports = __webpack_public_path__ + "fonts/7eba6f31347b31d9dd2c45478b4fb4cd.svg";